import autoImporter from '@modules/auto-importer';

const requireComponent = require.context(
  './',
  true,
  /^\.\/([\w-]+)\/(\1[\w.]*|index)\.(?:tsx|ts|js|scss)$/
);

export const components = autoImporter(requireComponent);
